import { Column, Row } from '@/components/container/Container';
import HeaderActions from '@/components/header/HeaderActions';
import { cn } from '@/components/ui/cn';
import routes, { routeWithId } from '@/constants/routes';
import { useNavigate } from 'react-router-dom';

const ConciergeHeader = ({ marginClass = 'mx-2 mt-2' }: { marginClass?: string }) => {
	const navigate = useNavigate();
	return (
		<header className={cn(marginClass, 'relative px-10 py-4 bg-neutralVariant100 rounded-full')}>
			<Row className="justify-between items-center">
				<Column>
					<img src="/images/concierge/xpress-for-business-logo.svg"
						alt="Xpress for Business" height={16} width={144}
						onClick={() => navigate(routes['/'])}
						className="cursor-pointer"
					/>
					<img src="/images/concierge/xpress-concierge-logo.svg"
						alt="Xpress Concierge" height={24} width={144}
						onClick={() => navigate(routeWithId('/concierge/statuses/:id', 0))}
						className="cursor-pointer"
					/>
				</Column>
				<HeaderActions />
			</Row>
		</header>
	);
};

export default ConciergeHeader;
